<template>

  <CommonPrivateView>
    <template v-slot:header>
      
      <div class="w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]">
        <div v-if="usuarioEmpresa">{{usuarioEmpresa.empresa.razonSocial}}</div>
      </div>

    </template>
    <template v-slot:content>
      
      <div class="container w-full mx-auto">

        <!-- FORM CARD -->
        <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5">
          <div class="flex items-center justify-between font-semibold text-lg ">
            PRODUCTOS
          </div>

          <div class="container mx-auto block w-full mt-4 space-y-4">

            <div class="w-full flex flex-col text-center md:flex-row gap-2">
              <router-link to="/producto" class="cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white">
                <font-awesome-icon :icon="['fas', 'plus']" /> 
                AGREGAR PRODUCTO
              </router-link>
            </div>
            
            <div class="w-full flex flex-col">
              <InputGroup>
                <InputText @keyup="filtrar" v-model="filtroTexto" placeholder="Buscar..." class="input-group-base bg-gray-50"/>
                <Button @click="limpiarFiltro" icon="pi pi-times" class="border borde-red-700 bg-red-700 text-white hover:bg-transparent hover:text-red-700 hover:border-red-700" />
              </InputGroup>
            </div>

            <DataView :value="productosFiltrados" paginator :rows="16" :alwaysShowPaginator="false" dataKey="item.id">
              <template #empty>
                <div class="grid grid-cols-1 text-2xl font-semibold text-center text-gray-500 min-h-32 bg-white">
                  No hay productos creados
                </div>
              </template>
              <template #list="slotProps">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm pb-6 bg-white">
                  <div v-for="(item, index) in slotProps.items" :key="index">
                    <div class="p-3 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center flex flex-col">

                      <div class="flex flex-col w-full space-y-2 flex-grow">
                        <div class="w-full aspect-square overflow-hidden rounded-lg border border-gray-300">
                          <img :src="item.previewFotoFile" class="w-full h-full object-cover object-center" />
                        </div>
                        <div class="font-semibold line-clamp-1">
                          {{ item.descripcion }}
                        </div>
                        <div class="text-gray-600 text-sm line-clamp-2">
                          {{ item.detalles || '&nbsp;' }}
                        </div>
                        <div class="w-full flex flex-col mt-auto">
                          <router-link :to="'/producto/' + item.id" class="py-1 mt-2 block rounded border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer">
                            <font-awesome-icon :icon="['fas', 'pencil']" /> EDITAR
                          </router-link>
                          <a @click="eliminarProducto(item)" class="py-1 mt-2 block rounded border border-red-500 bg-transparent text-red-500 hover:bg-red-500 hover:text-white cursor-pointer">
                            <font-awesome-icon :icon="['fas', 'user-minus']" /> ELIMINAR
                          </a>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </template>
            </DataView>

          </div>
        </div>
        <!-- FORM CARD -->

      </div>
      

    </template>
  </CommonPrivateView>

  <BlockUI :blocked="isSubmitting" fullScreen/>
  
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import DataView from 'primevue/dataview';
import InputText from 'primevue/inputtext';
import InputGroup from 'primevue/inputgroup';
import Button from 'primevue/button';

import CommonPrivateView from '@/components/commons/CommonPrivateView.vue';

import suiteConfig from '@/services/suite.config';
import empresaService from 'qreventos-suite/empresas';
import { Evento, UsuarioEmpresa, EmpresaProducto } from 'qreventos-suite/src/services/suite.interfaces';

import seguridadServices from '@/services/seguridad.services';
import eventoServices from 'qreventos-suite/eventos';
import { formatDate } from '@/utils/formatters';

export default defineComponent({
  components: {
    DataView, InputText, InputGroup,
    BlockUI, Button,
    CommonPrivateView
  },
  created() {
    document.title = "Empresas";
  },
  data() {
    return {
      isSubmitting: false,
      evento: undefined as unknown as Evento,
      productos: [] as EmpresaProducto[],
      productosFiltrados: [] as EmpresaProducto[],
      filtroTexto: '',
      usuarioEmpresa: undefined as unknown as UsuarioEmpresa
    };
  },
  methods: {
    formatDate,
    async limpiarFiltro() {
      this.filtroTexto = '';
      this.productosFiltrados = this.productos;
    },
    async filtrar() {
      if(this.filtroTexto == '') {
        this.limpiarFiltro();
        return;
      }

      this.productosFiltrados = this.productos.filter(producto => 
          producto.descripcion.toLowerCase().indexOf(this.filtroTexto.toLowerCase()) != -1 ||
          producto.detalles.toLowerCase().indexOf(this.filtroTexto.toLowerCase()) != -1
      );
      
    },
    async reload() {
      try {
        this.isSubmitting = true;

        this.productos = await empresaService.findProductosBy(this.usuarioEmpresa.evento.id, this.usuarioEmpresa.empresa.id);
        this.productosFiltrados = this.productos;
        
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    async confirmaEliminar(producto:EmpresaProducto) {
      try {
        const eliminarResponse:String = await empresaService.removeProductoBy(this.usuarioEmpresa.evento.id, producto.id) as String;
        if(eliminarResponse == "Ok") {
          Swal.fire({ title: '¡Atención!', html: `Producto eliminado con éxito`, icon: 'info' })
            .then(() => {
              this.reload();
          });
        }
      }
      catch (error) {
        Swal.fire({ title: "Error", text: "" + error + "", icon: "error" })
          .then(() => {
            this.reload();
          });
      }  
    },
    async eliminarProducto(producto:EmpresaProducto) {
      Swal.fire({
        title: '¡Atención!',
        html: `¿Seguro que desea eliminar el producto <b>${producto.descripcion}</b>?<br/><br/>Esta operación es irreversible.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'SI, ELIMINARLO!',
        cancelButtonText: 'CANCELAR',
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {
          this.confirmaEliminar(producto);
        }
      });
    },
  },
  async mounted() {
    try {      
      empresaService.clientId = suiteConfig.clientId;
      empresaService.token = suiteConfig.token;

      eventoServices.clientId = suiteConfig.clientId;
      eventoServices.token = suiteConfig.token;

      this.usuarioEmpresa = seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;
      this.evento = await eventoServices.validarEvento(this.usuarioEmpresa.evento.id);

      await this.reload();      
    }
    catch (error) {
      Swal.fire({ title: "Error", text: 'Sesión expirada [' + error + ']', icon: "error" })
        .then(() => {
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        });
    }    
  }
});
</script>
